document.addEventListener("DOMContentLoaded", function () {

  // ==========================================
  // 1. SKIP LINKS INJECTION
  // ==========================================
  function injectSkipLink(targetSelector, parentSelector, linkText, targetCustomId, skipLinkId) {
    const targetElement = document.querySelector(targetSelector);
    const parentElement = document.querySelector(parentSelector);

    if (targetElement && parentElement) {
      if (!targetElement.id) {
        targetElement.id = targetCustomId || 'content';
      }

      const skipLink = document.createElement('a');
      skipLink.href = '#' + targetElement.id;
      skipLink.className = 'skip-to-content-link'; 
      
      if (skipLinkId) {
        skipLink.id = skipLinkId;
      }
      
      skipLink.textContent = linkText;
      parentElement.insertBefore(skipLink, parentElement.firstChild);
    }
  }

  // Global Site Skip
  injectSkipLink('main', 'header', 'Skip to main content', 'content', 'skip-link-global');

  // Search & Collection Page Skip
  injectSkipLink(
    '.collection-content',
    '.collection-sidebar-container',
    'Skip filters and view results',
    'collection-results-target',
    'skip-link-filter'
  );


  // ==========================================
  // 2. HEADER MENU FOCUS TRAP (NEW)
  // ==========================================
  const toggleButton = document.querySelector('.header__main-toggle');
  const menuOverlay = document.querySelector('.header__menu');

  if (toggleButton && menuOverlay) {
    let handleTabTrap = null;

    menuOverlay.id = menuOverlay.id || 'header-menu';
    toggleButton.setAttribute('aria-controls', menuOverlay.id);
    toggleButton.setAttribute('aria-expanded', 'false');
    menuOverlay.setAttribute('role', 'dialog');
    menuOverlay.setAttribute('aria-modal', 'true');
    menuOverlay.setAttribute('aria-label', 'Main menu');

    function enableFocusTrap(container) {
      const getFocusable = () => Array.from(container.querySelectorAll('a[href], button, input:not([type="hidden"]), textarea, select, summary, [tabindex]:not([tabindex="-1"])'))
        .filter(el => !el.disabled && el.checkVisibility({ visibilityProperty: true }));

      [0, 50, 150, 350].forEach(delay => setTimeout(() => {
        if (!container.contains(document.activeElement)) getFocusable()[0]?.focus();
      }, delay));

      handleTabTrap = function (e) {
        if (e.key !== 'Tab') return;

        const focusableElements = getFocusable();
        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        if (!container.contains(document.activeElement)) {
          e.preventDefault();
          firstFocusable?.focus();
          return;
        }

        if (e.shiftKey) {
          // Shift + Tab (Backward)
          if (document.activeElement === firstFocusable) {
            e.preventDefault();
            lastFocusable.focus();
          }
        } else { 
          // Tab (Forward)
          if (document.activeElement === lastFocusable) {
            e.preventDefault();
            firstFocusable.focus();
          }
        }
      };

      document.addEventListener('keydown', handleTabTrap);
    }

    function disableFocusTrap(container) {
      if (handleTabTrap) {
        document.removeEventListener('keydown', handleTabTrap);
        handleTabTrap = null;
      }
    }

    let wasOpen = false;
    new MutationObserver(() => {
      const isOpen = menuOverlay.classList.contains('visible');
      if (isOpen === wasOpen) return;
      wasOpen = isOpen;
      toggleButton.setAttribute('aria-expanded', String(isOpen));

      if (isOpen) {
        enableFocusTrap(menuOverlay);
      } else {
        disableFocusTrap(menuOverlay);
        toggleButton.focus();
      }
    }).observe(menuOverlay, { attributes: true, attributeFilter: ['class'] });

    // Escape key listener on overlay
    menuOverlay.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const closeButton = menuOverlay.querySelector('[class*="close"], [aria-label*="lose"]');
        (closeButton || toggleButton).click();
      }
    });
  }


  // ==========================================
  // 3. MOVE SCROLL-TO-TOP LINK INTO END OF MAIN
  // ==========================================
  const bodyElement = document.body;

  const observer = new MutationObserver(function (mutations, observerInstance) {
    const scrollToTop = document.getElementById("bc-sf-filter-scroll-to-top");

    if (scrollToTop) {
      if (scrollToTop.parentElement.tagName !== "ASIDE") {
        const asideWrapper = document.createElement("aside");
        asideWrapper.setAttribute("aria-label", "Scroll to top");
        
        scrollToTop.parentNode.insertBefore(asideWrapper, scrollToTop);
        asideWrapper.appendChild(scrollToTop);

        scrollToTop.addEventListener('click', function() {
          const mainElement = document.getElementById("content");
          if (mainElement) {
            mainElement.setAttribute('tabindex', '-1');
            mainElement.focus();
          }
        });

        observerInstance.disconnect();
      }
    }
  });

  observer.observe(bodyElement, {
    childList: true,
    subtree: true
  });

});